export default __webpack_public_path__ + "static/media/txt_title4.a16b6d13.svg";